import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { fromDate } from "../reducers/formsReducer";

export const useInitialValues = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		let shouldUpdate = false;

		if (!searchParams.has("start")) {
			searchParams.set("start", encodeURIComponent(fromDate.toJSON()));
			shouldUpdate = true;
		}

		if (!searchParams.has("end")) {
			searchParams.set(
				"end",
				encodeURIComponent(
					moment().hour(23).minute(59).second(59).toDate().toJSON(),
				),
			);
			shouldUpdate = true;
		}
		if (!searchParams.has("status")) {
			searchParams.set("status", "All");
			shouldUpdate = true;
		}

		if (shouldUpdate) setSearchParams(searchParams, { replace: true });
	}, [searchParams]);
};
